import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { WorkflowEtapeInstance } from '../../bo/workflowEtapeInstance';
import { UtilisateurService } from '../../services/utilisateur.service';

@Component({
  selector: 'app-fil-ariane',
  templateUrl: './fil-ariane.component.html',
  styleUrls: ['./fil-ariane.component.scss'],
  standalone: false
})
export class FilArianeComponent {
  constructor(public utilService: UtilisateurService, public router: Router) { }

  navToMesProjets() {
    this.utilService.currentEtape = new WorkflowEtapeInstance();
    this.router.navigate(['/mysite', this.utilService.currentSite().siteId, 'myprojects'], { replaceUrl: true });
  }

  navToMonProjet() {
    this.utilService.currentEtape = new WorkflowEtapeInstance();
    this.router.navigate(['mysite', this.utilService.currentSite().siteId, 'myprojects', this.utilService.currentProjet.projetId], { replaceUrl: true });
  }

  navToTir() {
    this.utilService.currentEtape = new WorkflowEtapeInstance();
    const navigationExtras: NavigationExtras = {
      queryParams: { blastId: this.utilService.currentTir.tirId },
      replaceUrl: true
    };
    this.router.navigate(['mysite', this.utilService.currentSite().siteId, 'myprojects', this.utilService.currentProjet.projetId], navigationExtras);
  }
}
